// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__-qzab","summary":"CartItem_summary__pPwMc","price":"CartItem_price__mK7WH","amount":"CartItem_amount__HB8E4","actions":"CartItem_actions__kpqjh"};